import React from 'react'
import { uuid } from 'uuidv4'
import { Col, Row, Tag } from 'antd'

interface VariantNameAndAvatarProps {
  name: string
  testId: string | undefined
  options: string[]
}

const VariantNameAndAvatar = ({
  name,
  testId,
  options
}: VariantNameAndAvatarProps) => {
  return (
    <Row align='middle' gutter={[8, 8]} className='_mb-0'>
      {!!(options || []).length ? (
        <Col span={18}>
          <Row className='_mb-0' gutter={[8, 8]}>
            {options.map((option) => (
              <Tag
                className='-basic'
                key={uuid()}
                data-testid={`${testId}-permutation`}
              >
                {option}
              </Tag>
            ))}
          </Row>
        </Col>
      ) : (
        <Col>
          <span data-testid={testId}>{name}</span>
        </Col>
      )}
    </Row>
  )
}

export default VariantNameAndAvatar
